import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";
import { TwoFactorAuthIconDetails } from "@obg/ngx.common/src/two-factor-auth/two-factor-auth.model";

@Component({
	selector: "obg-m-verification-code-header",
	templateUrl: "verification-code-header.component.html",
	styleUrls: ["./verification-code-header.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class VerificationCodeHeaderComponent {
	@HostBinding("class.obg-m-verification-code-header") hostCssClass = true;

	@Input() title = "";
	@Input() icon!: TwoFactorAuthIconDetails;
}
